import { gql } from '@apollo/client'

export const CHANGE_ROOM = gql`
  mutation ChangeRoom($input: RoomInput) {
    changeRoom(input: $input) {
      room_id
      room_group_id
      room_group_name
      location_data_id
      location_id
      name
      description
      elektra_scene_idx
      color
    }
  }
`

export const REMOVE_ROOM = gql`
  mutation RemoveRoom($room_id: Int) {
    removeRoom(room_id: $room_id) {
      room_id
    }
  }
`
